import { Box } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SystemButton from "../../UIToolkit/SystemButton/SystemButton";

type Props = {
	name: string;
	/** No open spot left: Approve is off, since it would put more people on the shift than it needs. */
	full: boolean;
	onApprove: () => void;
	onDecline: () => void;
};

/** Decide on the sign-up right here: Don't approve, Approve. */
export const OutreachApprovalWaitingActions: FC<Props> = ({ name, full, onApprove, onDecline }) => {
	const { t } = useTranslation();
	return (
		<Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
			<SystemButton
				data-testid="outreach-approval-decline"
				buttonVariant="borderless"
				noFullWidthMobile
				aria-label={t("request.outreach.approval.decline_aria", { name })}
				onClick={onDecline}
			>
				{t("request.outreach.approval.decline")}
			</SystemButton>
			<SystemButton
				data-testid="outreach-approval-approve"
				buttonVariant="primary"
				noFullWidthMobile
				disabled={full}
				aria-label={t("request.outreach.approval.approve_aria", { name })}
				onClick={onApprove}
			>
				{t("approve")}
			</SystemButton>
		</Box>
	);
};
